module.exports = __webpack_public_path__ + "static/media/media.ea524865.png";